import React from 'react';
import Unpaid from '../../billing/Unpaid';

const UnpaidTab = () => <Unpaid />;

export default UnpaidTab;
